"use strict";
exports.__esModule = true;
exports.RECURRENCE = void 0;
var RECURRENCE = {
    WEEKLY: 'weekly',
    FORTNIGHTLY: 'fortnightly',
    MONTHLY: 'monthly',
    HALF_YEARLY: 'half_yearly',
    ANNUALLY: 'annually',
    QUARTERLY: 'quarterly',
    IRREGULAR: 'irregular',
    DAILY: 'daily',
    ONE_OFF: 'one_off',
    SEASONAL: 'seasonal'
};
exports.RECURRENCE = RECURRENCE;
